// extracted by mini-css-extract-plugin
module.exports = {"noticeModal":"Notice_noticeModal__2BVWJ","noticeModal_hight":"Notice_noticeModal_hight__nfysm","optionBtn":"Notice_optionBtn__3WWvm"};